<div class="col-md-12">
  <div class="row">
    
    <div class="col-md-2 menu-navigation">
      <nav class="nav-section">
        <ul class="menu-list">
          <li routerLinkActive="active"><a routerLink="User-List" >User List</a></li>
          <li routerLinkActive="active"><a routerLink="User-Log" >User Log</a></li>
          <li routerLinkActive="active"><a routerLink="User-Action-Log" >User Action Log</a></li>
          <li routerLinkActive="active"><a routerLink="Add-User" >Add User</a></li>
          <!-- to_remove -->
          <li routerLinkActive="active"><a routerLink="Change-Password" >Change Password</a></li>
        </ul>
      </nav>
    </div>

    <div class="col-md-10">
      <router-outlet></router-outlet>
    </div>

  </div>
</div>